import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const M_PER_NEW_02_Schema = {
  fields: {
    baseInfo: {
      pmCd: { initial: '', label: '허가서코드' },

      siteName: {
        initial: '',
        label: '현장명',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM'],
        step: 1,
        order: 10,
        placeholder: '현장명을 입력하세요',
        maxLength: 256,
      },
      permissionDate: {
        initial: dayjs().format('YYYY-MM-DD'),
        label: '작업허가일자',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM'],
        step: 1,
        order: 20,
        type: 'date',
        role: 'permissionDate',
      },
      permissionNo: {
        initial: '',
        label: '작업허가번호',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM'],
        step: 1,
        order: 30,
        format: 'numeric',
      },
      constructionNm: {
        initial: '',
        label: '공사업체명',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 40,
        placeholder: '공사 업체명을 입력하세요',
      },
      siteManager: {
        initial: '',
        label: '현장책임자',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 50,
      },
      sitePhone: {
        initial: '',
        label: '연락처',
        required: 'Y',
        group: 'construction',
        variants: ['CUSTOM', 'BASIC'],
        step: 1,
        order: 60,
        format: 'phone',
      },

      workStartDate: {
        initial: dayjs()
          .set('hour', 9)
          .startOf('hour')
          .format('YYYY-MM-DD HH:mm'),
        label: '작업일시(시작)',
        group: 'work',
        order: 110,
        type: 'datetime',
      },
      workEndDate: {
        initial: dayjs()
          .set('hour', 18)
          .startOf('hour')
          .format('YYYY-MM-DD HH:mm'),
        label: '작업일시(종료)',
        group: 'work',
        order: 115,
        type: 'datetime',
      },
      planNum: {
        initial: '',
        label: '계획인원',
        group: 'work',
        variants: ['CUSTOM'],
        order: 120,
        format: 'numeric',
      },
      workMemberNo: {
        initial: '',
        label: '투입인원',
        group: 'work',
        order: 130,
        format: 'numeric',
      },
      workPlace: {
        initial: '',
        label: '작업/공사위치',
        group: 'work',
        order: 140,
      },
      workDetail: {
        initial: '',
        label: '세부작업내용',
        group: 'work',
        order: 150,
      },
      guardian: {
        initial: '',
        label:
          '감시인(밀폐, 화기)\n최대작업 높이(고소)\n 중량(중량물)\n하역운반기계(운반로)',
        group: 'work',
        order: 160,
      },
      preventiveMeasures: {
        initial: '',
        label: '예방대책',
        group: 'work',
        order: 170,
      },
      etcContent: {
        initial: '',
        label: '기타 특별사항',
        group: 'work',
        order: 180,
      },
      workList: {
        initial: '',
        label: '작업자 명단',
        group: 'work',
        order: 190,
        type: 'workerList',
      },

      workTypeName: {
        initial: '',
        label: '작업종류',
        group: 'work',
        order: 999,
      },
    },
    departmentInfo: {
      depCd: { initial: '', label: '부서코드' },
      depNm: { initial: '', label: '부서명' },
      headId: { initial: '', label: '결재승인자ID' },
      headNm: { initial: '', label: '결재승인자명' },
    },

    codeInfo: {
      workTypes: { initial: [], label: '작업종류목록' },
      risks: {
        initial: [],
        label: '위험요인목록',
        codeKey: 'riskCode',
        nameKey: 'riskNm',
      },
      equips: {
        initial: [],
        label: '보호구목록',
        codeKey: 'workEquipCode',
        nameKey: 'workEquipNm',
      },
      preparations: {
        initial: [],
        label: '준비사항목록',
        codeKey: 'preparationCode',
        nameKey: 'preparationNm',
      },
    },
  },
  mapper: {
    search1: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
      WorkDate: (context) => Commons.EncryptAES(context.search?.startDate),
      UserId: (context) => context.userInfo?.userid,
    },

    save1: {
      PmCd: (context) => {
        return Commons.EncryptAES(context.baseInfo?.pmCd || context?.pmCd);
      },

      Gubun: (context) => Commons.EncryptAES(context.gubun),

      ReturnDetail: (context) =>
        Commons.EncryptAES(
          context.gubun === '0' ? context.returnDetail || '' : ''
        ),

      CenterSignPath: (context) =>
        context.gubun === '1'
          ? Commons.EncryptAES(
              context.depSignPath || context.centerSignPath || ''
            )
          : '',

      SmSignPath: (context) =>
        context.gubun === '2'
          ? Commons.EncryptAES(context.smSignPath || '')
          : '',

      UserId: (context) => context.userInfo?.userid,

      DtlCd: (context) => Commons.EncryptAES(''),
      CenterId: (context) => context.userInfo?.userid,
    },
    save2: {
      userId: (context) => context.userInfo?.userid,
      workEndGubun: (context) =>
        Commons.EncryptAES(String(context.workEndGubun ?? '')),
      dtlCd: (context) => {
        const rawValue = context.dtlCd;
        const stringValue = String(rawValue ?? '');
        const encryptedValue = Commons.EncryptAES(stringValue);

        // 로그 출력
        console.log('--- DTL_CD 검증 시작 ---');
        console.log('1. context 전체 객체:', context);
        console.log('2. 추출된 원본 값(dtlCd):', rawValue);
        console.log('3. 문자열 변환 값:', stringValue);
        console.log('4. 암호화 결과 값:', encryptedValue);
        console.log('--- DTL_CD 검증 종료 ---');

        return encryptedValue;
      },
      witnessSignPath: (context) =>
        Commons.EncryptAES(String(context.witnessSignPath ?? '')),
      witnessSignDate: (context) =>
        Commons.EncryptAES(String(context.witnessSignDate ?? '')),
      witnessYn: (context) =>
        Commons.EncryptAES(String(context.witnessYn ?? 'N')),
      witnessId: (context) => context.userInfo?.userid,
      riskRows: () => [],
      equipRows: () => [],
      prepRows: (context) =>
        (context.prepRows || []).map((row) => ({
          preparationCode: Commons.EncryptAES(
            String(row.preparationCode ?? '')
          ),
          witnessCheck: Commons.EncryptAES(String(row.witnessCheck ?? '')),
        })),
      detailRows: (context) =>
        (context.detailRows || []).map((detail) => ({
          dtlCd: Commons.EncryptAES(String(detail.dtlCd ?? '')),
          witnessSignPath: Commons.EncryptAES(
            String(detail.witnessSignPath ?? '')
          ),
          witnessSignDate: Commons.EncryptAES(
            String(detail.witnessSignDate ?? '')
          ),
          witnessYn: Commons.EncryptAES(String(detail.witnessYn ?? 'N')),
          witnessId: context.userInfo?.userid,
          checkRemark: Commons.EncryptAES(String(detail.checkRemark ?? '')),
          riskRows: [],
          equipRows: [],
          prepRows: (detail.prepRows || []).map((row) => ({
            preparationCode: Commons.EncryptAES(
              String(row.preparationCode ?? '')
            ),
            witnessCheck: Commons.EncryptAES(String(row.witnessCheck ?? '')),
          })),
        })),
    },
    delete1: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
    },
    save6: {
      smId: (context) => context.userInfo?.userid,
      gubun: (context) => Commons.EncryptAES(String(context.gubun ?? '')),
      smSignPath: (context) =>
        Commons.EncryptAES(String(context.smSignPath ?? '')),
      returnReason: (context) =>
        Commons.EncryptAES(String(context.returnReason ?? '')),
      dtlCds: (context) =>
        (context.dtlCds || []).map((cd) =>
          Commons.EncryptAES(String(cd ?? ''))
        ),
    },
  },
};
